<template>
    <div class="row mx-0">
        <div class="col-md-12 main-content">
            <h1 class="first-header heading-large">
                <i class="fas fa-users mr-2"></i> Manage Sellers
            </h1>
            <start-conversation-new-seller v-if="showStartConversation" v-bind:account="account" v-on:hideStartConversation='hideStartConversation()' v-on:toggleValue='toggleValue'/>
            <div 
                class="table-container"
                :class="{'card' : !$breakpoint.mdAndDown}"
            >
                <div class="table-title">
                </div>
                <div v-if="getSupplierList.length < 1"
                    class="alert alert-secondary mt-3 text-center">
                    <i class="fas fa-info-circle mr-2"></i>No suppliers found
                </div>
                <table v-else class="table responsive-table">
                    <thead>
                        <tr>
                            <th>
                                Sellers
                                <i v-if="activeSortColumn == 'seller' && activeSortDirection == 'asc'" 
                                    class="fas fa-sort-alpha-down sort-icon" :class="{'selected': activeSortColumn == 'seller' && activeSortDirection == 'asc'}" 
                                    size="lg" @click="sortColumn('seller', 'desc')"></i>
                                <i v-else class="fas sort-icon" 
                                    :class="activeSortColumn == 'seller' && activeSortDirection == 'desc'? ['selected','fa-sort-alpha-up'] : 'fa-sort-alpha-down' " 
                                    size="lg" @click="sortColumn('seller', 'asc')"></i>
                            </th>
                            <th>
                                Credit Limit
                                <i v-if="activeSortColumn == 'credit_limit' && activeSortDirection == 'asc'" 
                                    class="fas fa-sort-alpha-down sort-icon" :class="{'selected': activeSortColumn == 'credit_limit' && activeSortDirection == 'asc'}" 
                                    size="lg" @click="sortColumn('credit_limit', 'desc')"></i>
                                <i v-else class="fas sort-icon" 
                                    :class="activeSortColumn == 'credit_limit' && activeSortDirection == 'desc'? ['selected','fa-sort-alpha-up'] : 'fa-sort-alpha-down' " 
                                    size="lg" @click="sortColumn('credit_limit', 'asc')"></i>
                            </th>
                            <th>
                                Payment Terms
                                <i v-if="activeSortColumn == 'credit_days' && activeSortDirection == 'asc'" 
                                    class="fas fa-sort-alpha-down sort-icon" :class="{'selected': activeSortColumn == 'credit_days' && activeSortDirection == 'asc'}" 
                                    size="lg" @click="sortColumn('credit_days', 'desc')"></i>
                                <i v-else class="fas sort-icon" 
                                    :class="activeSortColumn == 'credit_days' && activeSortDirection == 'desc'? ['selected','fa-sort-alpha-up'] : 'fa-sort-alpha-down' " 
                                    size="lg" @click="sortColumn('credit_days', 'asc')"></i>
                            </th>
                            <th class="text-center">View Prices</th>
                        </tr>
                    </thead>
                    <tbody class="hover-grey">
                        <tr 
                            v-for="(supplier, key) in getSupplierList" :key="key"
                            :class="{'pb-3' :  $breakpoint.smAndDown}"
                        >
                            <th :class="{'heading-medium' : $breakpoint.smAndDown}">{{supplier.name}}</th>
                            <td label="Credit Limit"><span v-if="supplier.credit == null || supplier.credit.limit == null">N/A</span><span v-else>£{{supplier.credit.limit | priceformat}}</span></td>
                            <td label="Payment Terms"><span v-if="supplier.credit == null|| supplier.credit.days == null">N/A</span><span v-else>{{supplier.credit.days | creditdaysformat}}</span></td>
                            <td v-if="supplier.enabled_first_time || supplier.seller_enabled" class="td-actions" label="View Prices">
                                <div class="d-flex justify-content-center td-sticky td-right-bottom">
                                    <span class="switch-value" :class="{selected: !supplier.enabled}">Off</span>
                                    <label class="switch">
                                        <input type="checkbox" class="on-off-toggler" :checked="supplier.enabled" 
                                            @click="toggleValue(supplier)">
                                        <span class="slider round"></span>
                                    </label>
                                    <span class="switch-value" :class="{selected: supplier.enabled}">On</span>
                                </div>
                            </td>
                            <td v-else-if="!supplier.enabled && !supplier.seller_enabled" class="td-actions">
                                <button @click="openSendMessageModal(supplier)" class="btn btn-secondary">Request Prices</button>
                            </td>
                            <td v-else class="td-actions">
                                <button type="button" class="btn btn-link text-tertiary" @click="openConversation(supplier)">
                                    Pending Approval
                                    <i class="fas fa-comments text-secondary ml-1" ></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>


<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import StartConversationNewSeller from '@/modals/StartConversationNewSeller.vue'
import ConversationStarterMixin from '@/mixins/ConversationStarterMixin'
import breakpoint from '@/mixins/index';


export default {
    mixins: [breakpoint, ConversationStarterMixin],
    data(){
        return {
            supplierList: [],
            activeSortColumn: 'seller',
            activeSortDirection: 'asc',
            account: {},
            showStartConversation : false
        }
    },
    components:{
        StartConversationNewSeller
    },
    created: function() {
        this.getRelationships()        
    },
    computed: {
        ...mapGetters('accounts',['getSuppliersChanges']),
        ...mapState('login', ['userLoggedIn']),
        ...mapGetters("offers", ['getHasExistingContracts']),
        getSupplierList:{
            get: function() {
                return this.getSuppliersChanges
            }
        }
    },
    watch: {
    },
    methods: {
        ...mapActions('accounts',['getRelationships']),
        ...mapGetters('login', ['getAccountType']),
        ...mapActions('offers', ['getLiveContractsList']),
        toggleValue: async function(supplier){
            const payload = { 
                buyerId: this.userLoggedIn.id,
                supplierId: supplier.id,
                newStatus: !supplier.enabled
            }
            const response = await this.axios.put('/api/editSupplier', payload)

            if (response.status == 200){
                this.getRelationships()
            }
            else {
                console.log('Error found:', response)
            }
        },
        openSendMessageModal: async function(supplier){
            this.account.name = supplier.name;
            this.account.id = supplier.id;
            this.account.enabled = supplier.enabled;
            this.showStartConversation = true;
        },
        openConversation: async function(supplier) {
            

            const accountUserid = await this.getExistingUserChat(supplier)

            if (accountUserid === -1){
                console.log("Account has no sellers");
            } else{
                    await this.goToOlfChat(accountUserid).catch(err =>{
                    console.log(err)
                });
            }
        },
        hideStartConversation(){
            this.showStartConversation = false
        },
        sortColumn: function(columnIndex, direction){
            let stringA = ''
            let stringB = ''

            this.activeSortDirection = direction
            this.activeSortColumn = columnIndex

            switch (columnIndex){
                case 'seller': // Sort by supplier name
                    return this.getSupplierList.sort((a, b) => {
                        stringA = a.name.toLowerCase()
                        stringB = b.name.toLowerCase()
                        
                        if (direction == 'asc'){
                            if (stringA < stringB) {return -1;}
                            if (stringA > stringB) {return 1;}
                            return 0;
                        }
                        else {
                            if (stringA < stringB) {return 1;}
                            if (stringA > stringB) {return -1;}
                            return 0;
                        }
                    })
                case 'credit_limit': // Sort by credit limit
                    return this.getSupplierList.sort((a, b) => {
                        stringA = a.credit ? a.credit.limit : 9007199254740991
                        stringB = b.credit ? b.credit.limit : 9007199254740991

                        if (direction == 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })
                case 'credit_days': // Sort by credit days
                    return this.getSupplierList.sort((a, b) => {
                        stringA = a.credit ? a.credit.days : 9007199254740991
                        stringB = b.credit ? b.credit.days : 9007199254740991

                        if (direction == 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })
                default:
                    return
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.table-title {
    height: 2rem;
}

th, td {
    &:not(:first-of-type) {
        text-align: center;
    }
}
</style>